import { render, staticRenderFns } from "./CultureFiche.vue?vue&type=template&id=41d8d4f0"
import script from "./CultureFiche.vue?vue&type=script&lang=js"
export * from "./CultureFiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports